<template>
  <div class="billing-invoicing-wrapper">
    <InvoicingTab hide-summary-cards />
  </div>
</template>

<script>
import InvoicingTab from '@components/billing/InvoicingTab.vue'

export default {
  name: 'CompanyBillingInvoicing',
  components: {
    InvoicingTab
  },

  props: {
    company: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.billing-invoicing-wrapper {
  padding-top: 8px;
}
</style>
